import {
    apiRequest,
    acteknisCreate,
    masterCategoriestek
} from "../../../../../services/adapters/kepegawaian/Accompetence"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", acteknisCreate, {
            body: query
        }, true)
    }

    fetchCategories = async (query) => {
        return await apiRequest("get", masterCategoriestek, {
            params: query
        }, true)
    }
}

export default CreateRepository